function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import cloneDeep from 'lodash/cloneDeep';
import memoize from 'lodash/memoize';
import moment from 'moment';
import addIndex from 'ramda/src/addIndex';
import any from 'ramda/src/any';
import clone from 'ramda/src/clone';
import comparator from 'ramda/src/comparator';
import compose from 'ramda/src/compose';
import curry from 'ramda/src/curry';
import descend from 'ramda/src/descend';
import filter from 'ramda/src/filter';
import find from 'ramda/src/find';
import findIndex from 'ramda/src/findIndex';
import flatten from 'ramda/src/flatten';
import forEachObjIndexed from 'ramda/src/forEachObjIndexed';
import groupBy from 'ramda/src/groupBy';
import head from 'ramda/src/head';
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import map from 'ramda/src/map';
import pathOr from 'ramda/src/pathOr';
import pipe from 'ramda/src/pipe';
import pluck from 'ramda/src/pluck';
import prop from 'ramda/src/prop';
import propEq from 'ramda/src/propEq';
import sort from 'ramda/src/sort';
import uniq from 'ramda/src/uniq';
import values from 'ramda/src/values';
import { createSelector } from 'reselect';
import Immutable from 'seamless-immutable';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import i18n from 'invision-core/src/components/i18n/i18n';
import { getFilterService } from 'invision-core/src/components/injectables/injector.helper';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeLoadedSelector, MetadataCodeTypeDictionarySelector, MetadataCodeTypeSelector, MetadataOptionsForCodeValuesSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { getUpperLimitAccess, hasAccess } from 'invision-core/src/components/security/permission.service';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { parseFilenameFromPath } from 'invision-core/src/components/upload/upload.helper';
import { BRI_ACTIVATION_STATUS } from 'invision-core/src/constants/pricing.plan.constants';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import { OFFER_STATUS_INDICATOR_STATUS } from 'invision-core/src/constants/status.constants';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { SUPPORTED_PAYMENT_INSTRUMENT_TYPES } from '../../components/customer/ewallet/ewallet.constants';
import { ACTIONS_ITEMS, GIFT_REDEMPTION_STATUS, IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_STATUSES, ORDER_STATUS, ORDER_TYPES, PAYMENT_STATUS } from '../../components/customer/orderHistory/orderDetails/order.details.constants';
import { USAGE_CAP_BEHAVIOR_TYPES } from '../../components/customer/servicesAndUsage/usageCaps/usage.caps.constants';
import CustomerCareLocaleKeys from '../../locales/keys';
import { CANCEL_ORDER_ACCESS, ISSUE_CREDIT_STANDARD_CURRENCY_LIMIT, ORDER_ACCESS, REFUND_LIMIT_AND_ACCESS, RESUBMIT_ORDER_ACCESS, SEND_GIFT_ORDER_ACCESS } from '../../security.attributes';
import { WorkflowStateEnum } from '../../utilities/workflow.state.enum';
import { NA } from '../constants/billing.payments.constants';
import { TREATMENT_STATUS } from '../constants/convergent.biller.constants';
import { PERIOD_TYPES } from '../helpers/customer.convergent.biller.helper';
import { addDeviceFinancingToServiceThumbnail } from '../helpers/customer.convergent.biller.selectors.helper';
import { getCustomerIdentifier } from '../helpers/customer.helper';
import { BILLER_RULE_QUANTITY_PRICE_TYPE, ENTITLEMENT_SHARE_STATUS } from './../../customercare.constants';
import { getFriendlyName } from './billing.payments.invoice.selectors.helper';
import { SubscriberDeviceFinancingDetailsSelector } from './customer.devices.selectors';
import { AvailableTypesMapSelector, IsAllPaymentInstrumentTypesAvailableSelector } from './customer.ewallet.selectors';
import { isPaymentInstrumentTypeAvailable } from './customer.ewallet.selectors.helpers';
import { IsCoolingPeriodEnabledSelector } from './customer.offerings.selectors';
import { CurrentAccountNumberSelector, CurrentCustomerIdSelector, CurrentOrderIdSelector, RouteParams, SelectedCustomerSelector } from './customer.selectors';
import { AvailableProductsInstancePropertiesLabelSelector } from './products.order.selectors';
import { getFormattedServiceAttributeValue, getSuspensionTypeByCode } from './services.list.selectors.helper';
import { entitlementsSelector } from './shared.entitlements.selectors';
export var ORDER_DETAILS_MORE_MENU_CONSTANTS = {
  CANCEL_ORDER: 1,
  COMPLETE_ORDER: 2,
  CREDIT_ORDER: 3,
  RESEND_GIFT_NOTIFICATION: 4,
  RESUBMIT_ORDER: 5,
  REVOKE_GIFT: 6,
  EDIT_ORDER: 7
};
var EMPTY_ARRAY = [];
var EMPTY_OBJECT = Immutable({});
var ConvergentBillerSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.convergentBiller;
});
export var IsFetchingOrderServiceDetailsSelector = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller.isFetchingOrderServiceDetails;
});
export var OrderServiceDetailsErrorSelector = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller.orderServiceDetailsError || null;
});
export var IsUpdatingOrderServiceDetailsSelector = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller.isUpdatingOrderServiceDetails;
});
export var UpdateOrderServiceDetailsErrorSelector = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller.updateOrderServiceDetailsError || null;
});
export var IsApplyCreditAvailableSelector = createImmutableSelector([AvailableTypesMapSelector, IsAllPaymentInstrumentTypesAvailableSelector, IsDbss, MetadataCodeTypeSelector(CODES.PaymentInstrumentType), UserSecurityAttributesSelector], function (availablePaymentInstrumentTypes, isAllPaymentInstrumentTypesAvailable, isDbss, paymentInstrumentTypes, userSecurityAttributes) {
  var isCheckRefundAvailable = isDbss ? isPaymentInstrumentTypeAvailable(SUPPORTED_PAYMENT_INSTRUMENT_TYPES.CHECK_REFUND, paymentInstrumentTypes, isAllPaymentInstrumentTypesAvailable, availablePaymentInstrumentTypes) : false;
  return isCheckRefundAvailable && hasAccess(userSecurityAttributes, REFUND_LIMIT_AND_ACCESS);
});
export var CurrentConvergentBillerSelector = createSelector([CurrentCustomerIdSelector, ConvergentBillerSelector], function (currentCustomerId, convergentBillers) {
  return convergentBillers ? convergentBillers.data[currentCustomerId] : null;
});
export var ConvergentBillerSubscriberSummarySelector = createSelector([CurrentConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.subscriberSummary : null;
});
export var ConvergentBillerSubscriberOfferingSummariesSelector = createSelector([ConvergentBillerSubscriberSummarySelector], function (subscriberSummary) {
  var offeringSummaries = pathOr(null, ['OfferingSummaries'], subscriberSummary);
  return offeringSummaries && !isEmpty(offeringSummaries) ? offeringSummaries : null;
});
export var ConvergentBillerSubscriberSummaryAccountsSelector = createSelector([CurrentConvergentBillerSelector], function (convergentBiller) {
  return pathOr(null, ['subscriberSummary', 'AccountSummaries'], convergentBiller);
});
export var ConvergentBillerSubscriberRemainingWriteOffAmountSelector = createSelector([CurrentConvergentBillerSelector], function (convergentBiller) {
  return pathOr(null, ['subscriberSummary', 'RemainingWriteOffAmount'], convergentBiller);
});
export var ConvergentBillerSubscriberSummaryServicesSelector = createSelector([ConvergentBillerSubscriberSummarySelector, MetadataCodeTypeDictionarySelector(CODES.ServiceAttribute), MetadataCodeTypeDictionarySelector(CODES.RegularExpression)], function (subscriberSummary, serviceAttributes, regularExpressions) {
  if (!subscriberSummary || !subscriberSummary.AccountSummaries) {
    return undefined;
  }
  return pipe(pluck('Services'), flatten(), pluck('ServiceIdentifier'), map(function (service) {
    return {
      serviceFriendlyName: service.FriendlyName || service.Value,
      serviceValue: service.Value,
      serviceValueFormatted: getFormattedServiceAttributeValue(service.ServiceAttributeId, service.Value, serviceAttributes, regularExpressions)
    };
  }))(subscriberSummary.AccountSummaries);
});
export var ConvergentBillerSubscriberSummaryServicesAvailableSelector = createSelector([ConvergentBillerSubscriberSummaryAccountsSelector, RouteParams], function (subscriberSummaryAccounts, routeParams) {
  if (!subscriberSummaryAccounts) {
    return undefined;
  }
  var services = [];
  subscriberSummaryAccounts.forEach(function (account) {
    if (account.Services) {
      account.Services.forEach(function (service) {
        var hasIndividualEntitlements = service.ServiceIdentifier && getFriendlyName(service.ServiceIdentifier) !== NA;
        var hasSharedEntitlements = !service.ServiceIdentifier && service.EntitlementBalances.length > 0;
        if (hasIndividualEntitlements || hasSharedEntitlements) {
          services.push(service);
        }
      });
    }
  });
  if (services) {
    var availableServices = services.map(function (service, index) {
      return {
        text: service.ServiceIdentifier ? getFriendlyName(service.ServiceIdentifier) : i18n.translate(CustomerCareLocaleKeys.HOUSEHOLD.SHARED_ENTITLEMENTS),
        ServiceIdentifier: service.ServiceIdentifier,
        selected: routeParams.serviceIdentifierValue === service.ServiceIdentifier.Value,
        service: service,
        index: index
      };
    });
    return availableServices;
  }
  return null;
});
export var ConvergentBillerSubscriberSummaryPostPaidAccountSelector = createSelector([ConvergentBillerSubscriberSummaryAccountsSelector], function (accountSummaries) {
  if (!accountSummaries) {
    return EMPTY_ARRAY;
  }
  return accountSummaries.filter(function (acct) {
    return acct.PostpaidDetails;
  });
});
export var ConvergentBillerSubscriberSummaryPrePaidAccountSelector = createSelector([ConvergentBillerSubscriberSummaryAccountsSelector], function (accountSummaries) {
  if (!accountSummaries) {
    return EMPTY_ARRAY;
  }
  return accountSummaries.filter(function (acct) {
    return acct.PrepaidDetails;
  });
});
export var CurrentAccountSummarySelector = createSelector([ConvergentBillerSubscriberSummarySelector, CurrentAccountNumberSelector], function (subscriberSummary, currentAccountNumber) {
  if (pathOr(0, ['AccountSummaries', 'length'], subscriberSummary) === 0) {
    return null;
  }
  var currentAccountSummary = null;
  if (currentAccountNumber) {
    currentAccountSummary = find(propEq(currentAccountNumber, 'AccountNumber'))(subscriberSummary.AccountSummaries);
  } else {
    currentAccountSummary = subscriberSummary.AccountSummaries[0];
  }
  if (currentAccountSummary && currentAccountSummary.PostpaidDetails) {
    currentAccountSummary = currentAccountSummary.merge({
      currencyCode: pathOr('', ['PostpaidDetails', 'CurrencyCode'], currentAccountSummary).substring(0, 3)
    }, {
      deep: true
    });
  }
  return currentAccountSummary;
});
export var CurrentPostPaidAccountSummarySelector = createSelector([ConvergentBillerSelector, ConvergentBillerSubscriberSummaryPostPaidAccountSelector, CurrentAccountNumberSelector], function (convergentBiller, postPaidAccounts, currentAccountNumber) {
  if (postPaidAccounts.length === 0) {
    return null;
  }
  if (currentAccountNumber) {
    return find(propEq(currentAccountNumber, 'AccountNumber'), postPaidAccounts);
  }
  return postPaidAccounts[0];
});
export var CurrentAccountSummaryTotalSelector = createSelector([CurrentAccountSummarySelector], function (currentAccountSummary) {
  return pathOr(null, ['PostpaidDetails', 'Total'], currentAccountSummary);
});
export var CurrentPostPaidAccountSummaryTotalSelector = createSelector([CurrentPostPaidAccountSummarySelector], function (currentPostpaidAccount) {
  return pathOr(0, ['PostpaidDetails', 'Balance'], currentPostpaidAccount);
});
export var AccountsNumberSelector = createSelector([ConvergentBillerSubscriberSummarySelector], function (subscriberSummary) {
  var prepaidItems = [];
  var postpaidItems = [];
  if (subscriberSummary && subscriberSummary.AccountSummaries && subscriberSummary.AccountSummaries.length) {
    subscriberSummary.AccountSummaries.forEach(function (account) {
      (account.PostpaidDetails ? postpaidItems : prepaidItems).push({
        title: account.AccountNumber,
        number: account.AccountNumber
      });
    });
  }
  return [{
    items: prepaidItems,
    title: i18n.translate(CustomerCareLocaleKeys.OFFERING_CHARGE_TYPES.PREPAID)
  }, {
    items: postpaidItems,
    title: i18n.translate(CustomerCareLocaleKeys.OFFERING_CHARGE_TYPES.POSTPAID)
  }];
});
export var NumberOfAccountsSelector = createSelector([ConvergentBillerSubscriberSummarySelector], function (subscriberSummary) {
  if (subscriberSummary && subscriberSummary.AccountSummaries && subscriberSummary.AccountSummaries.length) {
    return subscriberSummary.AccountSummaries.length;
  }
  return 0;
});
export var HasPrepaidAndPostpaidOffersSelector = createSelector([ConvergentBillerSubscriberSummaryAccountsSelector], function (accounts) {
  if (accounts && accounts.length > 1) {
    var prepaidAccountServices = accounts.some(function (account) {
      return account.PrepaidDetails && account.Services.length > 0;
    });
    var postpaidAccountServices = accounts.some(function (account) {
      return account.PostpaidDetails && account.Services.length > 0;
    });
    return prepaidAccountServices && postpaidAccountServices;
  }
  return false;
});
export var IsCurrentAccountPostpaidSelector = createSelector([CurrentAccountSummarySelector], function (currentAccount) {
  return !!(currentAccount && currentAccount.PostpaidDetails);
});
export var CurrentAccountServicesSelectorHelper = createSelector([CurrentAccountSummarySelector], function (currentAccountSummary) {
  return currentAccountSummary && currentAccountSummary.Services ? currentAccountSummary.Services.map(function (service) {
    return Object.assign({}, service, {
      SuspendType: getSuspensionTypeByCode(service.SuspendTypeCode)
    });
  }) : [];
});
export var CurrentAccountCurrencyCodeSelector = createSelector([CurrentAccountSummarySelector], function (currentAccountSummary) {
  return pathOr('', ['PostpaidDetails', 'CurrencyCode'], currentAccountSummary).substring(0, 3);
});
export var ConvergentBillerCurrencyCodeSelector = createSelector([ConvergentBillerSubscriberSummarySelector], function (convergentBiller) {
  return convergentBiller && convergentBiller.Currency;
});
export var CurrentSharedEntitlementBalancesSelector = createSelector([entitlementsSelector, MetadataCodeTypeSelector(CODES.UnitsOfMeasure), MetadataCodeTypeDictionarySelector(CODES.ServiceAttribute), MetadataCodeTypeDictionarySelector(CODES.RegularExpression)], function (entitlements, unitsOfMeasure, serviceAttributes, regularExpressions) {
  if (entitlements && unitsOfMeasure && unitsOfMeasure.length && Object.keys(serviceAttributes).length && Object.keys(regularExpressions).length) {
    return getMappedEntitlementBalances(entitlements || [], unitsOfMeasure, serviceAttributes, regularExpressions);
  } else {
    return null;
  }
});
export var IsARCSubscriptionMgmtFeatureToggleSelector = createSelector([CurrentAccountSummarySelector, MetadataCodeTypeSelector(CODES.MicroserviceConfiguration)], function (currentAccount, ARCSubscriptionMgmtFeature) {
  if (currentAccount && currentAccount.PrepaidDetails && ARCSubscriptionMgmtFeature.length) {
    var SubscriptionMgmtFeatures = ARCSubscriptionMgmtFeature[0];
    var ARCSubscriptionMgmtFeaturesToggle = SubscriptionMgmtFeatures ? SubscriptionMgmtFeatures.AdditionalProperties.find(function (item) {
      return item.Key === 'is_active';
    }) : [];
    return pathOr(null, ['Value'], ARCSubscriptionMgmtFeaturesToggle);
  } else {
    return false;
  }
});
var getRoundedUsageAmount = function getRoundedUsageAmount() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  if (value === null) {
    value = 0;
  }
  return value.toFixed(Number.isInteger(value) ? 0 : 2);
};
var getMappedEntitlementBalances = function getMappedEntitlementBalances(entitlements, unitsOfMeasure, serviceAttributes, regularExpressions) {
  return (entitlements || []).map(function (entitlementBalance) {
    var abbreviationPropertyKey = 'short_name';
    var unitOfMeasure = unitsOfMeasure.find(function (unit) {
      return unit.Value === entitlementBalance.BalanceUnitCode;
    });
    var shortName = unitOfMeasure ? unitOfMeasure.AdditionalProperties.find(function (prop) {
      return prop.Key === abbreviationPropertyKey;
    }).Value : undefined;
    if (entitlementBalance.EntitlementIdentifier && entitlementBalance.EntitlementIdentifier.OwningServiceIdentifier) {
      var owningService = entitlementBalance.EntitlementIdentifier.OwningServiceIdentifier;
      entitlementBalance = entitlementBalance.setIn(['EntitlementIdentifier', 'OwningServiceIdentifier', 'FormattedValue'], getFormattedServiceAttributeValue(owningService.ServiceAttributeId, owningService.Value, serviceAttributes, regularExpressions));
    }
    return entitlementBalance.set('ShareAction', i18n.translate(entitlementBalance.SharingStatus === ENTITLEMENT_SHARE_STATUS.DISABLED ? CustomerCareLocaleKeys.SHARING_ACTIONS.START_SHARING : CustomerCareLocaleKeys.SHARING_ACTIONS.STOP_SHARING)).set('BalanceConsumed', getRoundedUsageAmount(entitlementBalance.BalanceConsumed || 0)).set('BalanceRemaining', getRoundedUsageAmount(entitlementBalance.BalanceRemaining)).set('InitialBalance', getRoundedUsageAmount(entitlementBalance.InitialBalance || 0)).set('unitOfMeasure', shortName);
  });
};
var getCurrentAccountServices = function getCurrentAccountServices(currentAccountServices, unitsOfMeasure, currencyCode, serviceAttributeValues, serviceFeatures, serviceAttributes, regularExpressions) {
  return currentAccountServices.map(function (service) {
    var serviceUsageTotal = (service.UsageSubTotals || []).reduce(function (prev, curr) {
      return prev + curr.ChargeAmount;
    }, 0);
    var usageCharges = currencyCode && getFilterService()('invCurrency')(serviceUsageTotal, currencyCode);
    var serviceAttribute = serviceAttributeValues && serviceAttributeValues.length ? serviceAttributeValues.find(function (attribute) {
      return attribute && attribute.Value && attribute.ServiceId ? attribute.Value === service.ServiceIdentifier.Value : null;
    }) : null;
    var currentServiceFeatures = serviceFeatures && serviceFeatures.length ? serviceFeatures.filter(function (feature) {
      return feature.ServiceIdentifierValue === service.ServiceIdentifier.Value;
    }) : null;
    var UsageCaps = (service.UsageCaps || []).map(function (item) {
      var _find;
      var usageCapItem = clone(item);
      usageCapItem.ThresholdType.Name = (_find = (unitsOfMeasure || []).find(function (unitItem) {
        var _item$ThresholdType;
        return (item === null || item === void 0 ? void 0 : (_item$ThresholdType = item.ThresholdType) === null || _item$ThresholdType === void 0 ? void 0 : _item$ThresholdType.Code) && unitItem.Value === item.ThresholdType.Code.toString();
      })) === null || _find === void 0 ? void 0 : _find.Name;
      return usageCapItem;
    });
    return service.set('EntitlementBalances', getMappedEntitlementBalances(service.EntitlementBalances, unitsOfMeasure, serviceAttributes, regularExpressions)).set('usageCharges', usageCharges).set('UsageCaps', UsageCaps).set('ServiceFeatures', currentServiceFeatures).setIn(['ServiceIdentifier', 'FormattedValue'], serviceAttribute && getFormattedServiceAttributeValue(serviceAttribute.ServiceAttributeId, serviceAttribute.Value, serviceAttributes, regularExpressions)).setIn(['ServiceIdentifier', 'ServiceId'], serviceAttribute && serviceAttribute.ServiceId ? serviceAttribute.ServiceId : null).setIn(['ServiceIdentifier', 'SubscriberProductId'], serviceAttribute && serviceAttribute.SubscriberProductId ? serviceAttribute.SubscriberProductId : null);
  });
};
var removePastInstallments = filter(function (_ref) {
  var InstallmentDueDate = _ref.InstallmentDueDate;
  return moment(InstallmentDueDate).isAfter(moment());
});
var PROMISE_STATUS = {
  OPEN: 0,
  COMPLETED: 1
};
var removeCompletedInstallments = filter(function (_ref2) {
  var PromiseStatus = _ref2.PromiseStatus;
  return PromiseStatus === PROMISE_STATUS.OPEN;
});
var dateStringComparator = comparator(function (a, b) {
  return moment(a.InstallmentDueDate).isBefore(b.InstallmentDueDate);
});
var getEarliestDueDateInstallment = sort(dateStringComparator);
var assignPeriodToInstallment = curry(function (periodTypes, result) {
  var period = periodTypes.find(function (type) {
    return parseInt(type.Value, 10) === result.PeriodType;
  }) || {};
  return result.set('period', period.Name || i18n.translate(CustomerCareLocaleKeys.TREATMENT_DETAILS.NA));
});
var getMappedPromiseToPayDetails = function getMappedPromiseToPayDetails(promiseToPayDetails, periodTypes) {
  var validDetails = compose(removeCompletedInstallments, removePastInstallments)(promiseToPayDetails);
  return validDetails.length > 0 ? compose(assignPeriodToInstallment(periodTypes), head, getEarliestDueDateInstallment)(validDetails) : null;
};
export var ConvergentBillerInvoicesSelector = createSelector([CurrentConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.invoices : null;
});
export var ConvergentBillerDepositsSelector = createSelector([CurrentConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.deposits : null;
});
export var ConvergentBillerTreatmentDetailsSelector = createSelector([CurrentConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.treatmentDetails : null;
});
export var ConvergentBillerOrderServiceDetailsSelector = createSelector([CurrentConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.orderServiceDetails : null;
});
export var ConvergentBillerOrderServiceDetailsFormattedSelector = createImmutableSelector([ConvergentBillerOrderServiceDetailsSelector, MetadataCodeTypeDictionarySelector(CODES.ServiceAttribute), MetadataCodeTypeDictionarySelector(CODES.RegularExpression)], function (orderServiceDetails, serviceAttributes, regularExpressions) {
  var orderServiceDetailsClone = clone(orderServiceDetails);
  orderServiceDetailsClone && Object.values(orderServiceDetailsClone).forEach(function (orderServiceDetails) {
    orderServiceDetails.forEach(function (orderServiceDetail) {
      (orderServiceDetail.ServiceAttributeValues || EMPTY_ARRAY).forEach(function (serviceAttribute) {
        serviceAttribute.FormattedValue = getFormattedServiceAttributeValue(serviceAttribute.ServiceAttributeId, serviceAttribute.Value, serviceAttributes, regularExpressions);
      });
    });
  });
  return orderServiceDetailsClone;
});
export var ConvergentBillerIsInPromiseToPay = createSelector([ConvergentBillerSubscriberSummarySelector], function (subscriberSummary) {
  return !!subscriberSummary && subscriberSummary.TreatmentStatus === TREATMENT_STATUS.IN_TREATMENT_WITH_P2P;
});
export var ConvergentBillerIsInTreatment = createSelector([ConvergentBillerSubscriberSummarySelector], function (subscriberSummary) {
  return !!subscriberSummary && subscriberSummary.TreatmentStatus !== TREATMENT_STATUS.NOT_IN_TREATMENT;
});
export var ConvergentBillerCurrentPromiseToPayInstallment = createSelector([ConvergentBillerIsInPromiseToPay, ConvergentBillerTreatmentDetailsSelector, MetadataCodeLoadedSelector(CODES.PeriodType), MetadataCodeTypeSelector(CODES.PeriodType)], function (isInPromiseToPay, treatmentDetails, periodLoaded) {
  var periods = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  return isInPromiseToPay && periodLoaded && treatmentDetails ? getMappedPromiseToPayDetails(treatmentDetails.PromiseToPayDetails, periods) : null;
});
var startDateComparator = function startDateComparator(a, b) {
  return moment(a.InstallmentStartDate).diff(b.InstallmentStartDate, 'seconds');
};
var mapInstallment = function mapInstallment(installment, index) {
  return installment.set('isPaid', installment.PromiseStatus === PROMISE_STATUS.COMPLETED ? i18n.translate(CustomerCareLocaleKeys.YES) : i18n.translate(CustomerCareLocaleKeys.NO)).set('installmentNumber', index + 1); // Want it to be non-zero based
};
export var ConvergentBillerCurrentPromiseToPaySchedule = createSelector([ConvergentBillerTreatmentDetailsSelector], function (treatmentDetails) {
  return treatmentDetails && treatmentDetails.PromiseToPayDetails ? compose(addIndex(map)(mapInstallment), sort(startDateComparator))(treatmentDetails.PromiseToPayDetails) : null;
});
export var PromiseToPayCreationErrorSelector = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.promiseToPayCreationError : null;
});
export var UpdateSubscriberTreatmentErrorSelector = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.updateSubscriberTreatmentError : null;
});
export var MostRecentInvoiceSelector = createSelector([CurrentAccountSummarySelector, ConvergentBillerInvoicesSelector], function (currentAccountSummary, invoices) {
  if (currentAccountSummary && currentAccountSummary.PostpaidDetails && invoices) {
    var invoiceId = currentAccountSummary.PostpaidDetails.LastInvoiceId;
    return invoiceId ? find(propEq(invoiceId, 'InvoiceId'))(invoices) : null;
  }
  return null;
});
export var MostRecentInvoiceBalanceSelector = createSelector([MostRecentInvoiceSelector], function (mostRecentInvoice) {
  return mostRecentInvoice ? mostRecentInvoice.Balance : null;
});
export var ConvergentBillerAccountDetailsSelector = createSelector([CurrentConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.accountDetails : null;
});
export var DisconnectRestrictedReasonTypeSelector = createSelector([ConvergentBillerAccountDetailsSelector], function (accountDetails) {
  return accountDetails ? accountDetails.disconnectRestrictedReasonType : undefined;
});
export var ConvergentBillerAccountHasBulkProducts = createSelector([ConvergentBillerAccountDetailsSelector], function (accountDetails) {
  var hasBulkProducts = false;
  if (accountDetails && accountDetails.offerings) {
    hasBulkProducts = accountDetails.offerings.some(function (offer) {
      return offer.Options && offer.Options.length ? offer.Options.some(function (option) {
        return option.IsBulkWithServices;
      }) : false;
    });
  }
  return hasBulkProducts;
});
export var ConvergentBillerAccountOfferingsSelector = createSelector([CurrentConvergentBillerSelector], function (convergentBiller) {
  return pathOr(false, ['accountDetails', 'offerings', 'length'], convergentBiller) ? convergentBiller.accountDetails.offerings.asMutable({
    deep: true
  }) : null;
});
export var ConvergentBillerAccountServiceFeaturesSelector = createSelector([ConvergentBillerAccountOfferingsSelector], function (offerings) {
  if (offerings && offerings.length) {
    var serviceFeatures = [];
    offerings.forEach(function (offer) {
      if (offer.ServiceFeatures && offer.ServiceFeatures.length) {
        offer.ServiceFeatures.forEach(function (feature) {
          if (feature.Status !== OFFER_STATUS_INDICATOR_STATUS.REMOVED) {
            serviceFeatures.push(feature);
          }
        });
      }
    });
    return serviceFeatures;
  }
  return EMPTY_ARRAY;
});
export var ConvergentBillerAccountOptionsServiceAttributeValuesSelector = createSelector([ConvergentBillerAccountOfferingsSelector], function (offerings) {
  if (offerings && offerings.length) {
    var serviceAttributeValues = [];
    offerings.forEach(function (offer) {
      if (offer && offer.Options && offer.Options.length) {
        offer.Options.forEach(function (option) {
          if (option && option.ServiceAttributeValues) {
            option.ServiceAttributeValues.forEach(function (serviceAttribute) {
              return serviceAttributeValues.push(Object.assign({}, serviceAttribute, {
                SubscriberProductId: option.SubscriberProductId
              }));
            });
          }
        });
      }
    });
    return serviceAttributeValues;
  }
  return EMPTY_ARRAY;
});
export var CurrentAccountServicesSelector = createSelector([CurrentAccountServicesSelectorHelper, MetadataCodeTypeSelector(CODES.UnitsOfMeasure), CurrentAccountCurrencyCodeSelector, ConvergentBillerAccountOptionsServiceAttributeValuesSelector, ConvergentBillerAccountServiceFeaturesSelector, MetadataCodeTypeDictionarySelector(CODES.ServiceAttribute), MetadataCodeTypeDictionarySelector(CODES.RegularExpression)], function (currentAccountServices, unitsOfMeasure, currencyCode, serviceAttributeValues, serviceFeatures, serviceAttributes, regularExpressions) {
  return (unitsOfMeasure && unitsOfMeasure.length) > 0 ? getCurrentAccountServices(currentAccountServices, unitsOfMeasure, currencyCode, serviceAttributeValues, serviceFeatures, serviceAttributes, regularExpressions) : EMPTY_ARRAY;
});
export var CurrentAccountServicesWithDeviceFinancingInfoSelector = createImmutableSelector([CurrentAccountServicesSelector, SubscriberDeviceFinancingDetailsSelector], function (services, deviceFinancingInfo) {
  return addDeviceFinancingToServiceThumbnail(services, deviceFinancingInfo);
});
export var CurrentAccountServiceUsageChargeSelector = createSelector([CurrentAccountServicesSelector, RouteParams], function (currentAccountServices, routeParams) {
  if (currentAccountServices) {
    var foundService = currentAccountServices.find(function (account) {
      return account.ServiceIdentifier.Value === routeParams.serviceIdentifierValue;
    });
    if (foundService) {
      return foundService.usageCharges;
    }
  }
  return null;
});
var sortedBillerType = function sortedBillerType(option) {
  if (option.BillerTypeAmounts && option.BillerTypeAmounts.length > 1) {
    option.BillerTypeAmounts.sort(function (a, b) {
      return b.TotalAmount - a.TotalAmount;
    });
  }
  return option;
};
export var ConvergentBillerTypeAmountSortedSelector = createSelector([ConvergentBillerAccountOfferingsSelector], function (offerings) {
  var clonedOfferings = offerings ? offerings.slice() : null;
  if (clonedOfferings) {
    clonedOfferings.forEach(function (offer) {
      offer.Options.forEach(function (option) {
        sortedBillerType(option);
      });
    });
  }
  return clonedOfferings || null;
});
export var OfferingIsOffCycleMapSelector = createImmutableSelector([ConvergentBillerAccountOfferingsSelector], function (offerings) {
  return (offerings || []).reduce(function (acc, offer) {
    acc[offer.OfferingInstanceId] = offer.HasOffCycleCharges;
    return acc;
  }, {});
});
export var ConvergentBillerSortedAccountOfferingsSelector = createSelector([ConvergentBillerTypeAmountSortedSelector], function (offerings) {
  var sortedOffers = offerings ? offerings.slice() : null;
  if (sortedOffers && sortedOffers.length > 1) {
    var offerTotalAmount = descend(prop('TotalAmount'));
    sortedOffers = sort(offerTotalAmount, offerings);
  }
  return sortedOffers;
});
var paymentAccountNumberMatches = function paymentAccountNumberMatches(accountNumbers, currentAccount) {
  return function (option) {
    // NOTE: `AccountNumber` is not defined for usage and entitlements
    return accountNumbers.includes(option.AccountNumber) && option.AccountNumber === (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.PaymentAccountNumber) || option.AccountNumber === undefined || option.Status === OFFER_STATUS_INDICATOR_STATUS.PENDING_ACTIVE || option.Status !== OFFER_STATUS_INDICATOR_STATUS.REMOVED ? option : null;
  };
};
export var ConvergentBillerAccountOfferingsForSelectedAccountSelector = createSelector([CurrentAccountSummarySelector, ConvergentBillerSubscriberSummarySelector, ConvergentBillerSortedAccountOfferingsSelector, ConvergentBillerSubscriberOfferingSummariesSelector, IsCoolingPeriodEnabledSelector], function (currentAccount, subscriberSummary, offerings, offeringSummaries, isCoolingPeriodEnabled) {
  var validOffers = [];
  if (offerings && subscriberSummary) {
    var accountNumbers = subscriberSummary.AccountSummaries.reduce(function (acc, account) {
      if (account !== null && account !== void 0 && account.PaymentAccountNumber) {
        acc.push(account.PaymentAccountNumber);
      }
      return acc;
    }, []);
    offerings.forEach(function (offer) {
      var newOfferOptions = filter(paymentAccountNumberMatches(accountNumbers, currentAccount), offer.Options);
      var orderContractInstance = offeringSummaries && offeringSummaries.length ? offeringSummaries.find(function (offeringSummary) {
        return offeringSummary.OfferingId === offer.OfferingId;
      }) : null;
      var currentPaymentInstrument = pathOr(null, ['PaymentInstrument'], (subscriberSummary.OfferingSummaries || []).find(function (offerSummary) {
        return offerSummary.OfferingInstanceId === offer.OfferingInstanceId;
      }));
      var offeringInstancePaymentInstrument = currentPaymentInstrument ? {
        PaymentInstrument: currentPaymentInstrument
      } : null;
      if (newOfferOptions.length || offer.IsCoolingOff && isCoolingPeriodEnabled) {
        if (orderContractInstance && orderContractInstance.OrderContractInstanceThumbnail) {
          validOffers.push(Object.assign({}, offer, {
            Options: newOfferOptions,
            OrderContractInstance: orderContractInstance.OrderContractInstanceThumbnail
          }, offeringInstancePaymentInstrument));
        } else {
          validOffers.push(Object.assign({}, offer, {
            Options: newOfferOptions
          }, offeringInstancePaymentInstrument));
        }
      }
    });
  }
  return validOffers.length ? validOffers : null;
});
export var CombinedEntitlementTypesSelector = createSelector(ConvergentBillerAccountOfferingsForSelectedAccountSelector, CurrentAccountServicesWithDeviceFinancingInfoSelector, CurrentSharedEntitlementBalancesSelector, function (acc, currentAccountServices, currentSharedEntitlementBalances) {
  var connectedDates = {};
  var HasOffCycleCharges = {};
  var opts = flatten(pluck('Options', acc || EMPTY_ARRAY));
  opts.forEach(function (el) {
    if (el && el.ServiceIdentifierValue && el.ConnectedDate) {
      connectedDates[el.ServiceIdentifierValue] = moment.utc(el.ConnectedDate).toISOString();
    }
    if (el && el.ServiceIdentifierValue) {
      HasOffCycleCharges[el.ServiceIdentifierValue.toString()] = acc.find(function (item) {
        return item.OfferingInstanceId === el.OfferingInstanceId;
      }).HasOffCycleCharges;
    }
  });
  return Immutable([].concat(_toConsumableArray(currentAccountServices || EMPTY_ARRAY), _toConsumableArray(currentSharedEntitlementBalances ? [Immutable({
    EntitlementBalances: currentSharedEntitlementBalances
  })] : EMPTY_ARRAY)).map(function (element) {
    var el = cloneDeep(element);
    el.HasOffCycleCharges = el.ServiceIdentifier && el.ServiceIdentifier.Value ? HasOffCycleCharges[el.ServiceIdentifier.Value] : null;
    el = Immutable(el);
    if (el && el.EntitlementBalances && el.EntitlementBalances.length) {
      return el.set('EntitlementBalances', el.EntitlementBalances.asMutable().map(function (entitlement) {
        if (entitlement.EntitlementIdentifier && entitlement.EntitlementIdentifier.GroupCode) {
          return entitlement;
        }
        if (entitlement.EntitlementIdentifier && entitlement.EntitlementIdentifier.OwningServiceIdentifier) {
          return entitlement.set('ConnectedDate', connectedDates[pathOr(-1, ['EntitlementIdentifier', 'OwningServiceIdentifier', 'Value'], entitlement)] || null);
        }
        if (entitlement.ServiceIdentifier) {
          return entitlement.set('ConnectedDate', connectedDates[pathOr(-1, ['ServiceIdentifier', 'Value'], entitlement)] || null);
        }
      }));
    } else if (el && el.ServiceIdentifier) {
      return el.set('ConnectedDate', connectedDates[pathOr(-1, ['ServiceIdentifier', 'Value'], el)] || null);
    }
    return el;
  }));
});
export var IsFetchingAccountDetailsSelector = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.isFetchingAccountDetails : false;
});
export var ConvergentBillerAccountUsageDetailsSelector = createSelector([CurrentConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.usageDetails : null;
});
export var ConvergentBillerSelectedServiceIdSelector = createSelector([CurrentConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.selectedServiceId : null;
});
export var ConvergentBillerAccountUsageDetailsByServiceIdSelector = createSelector([ConvergentBillerAccountUsageDetailsSelector, ConvergentBillerSelectedServiceIdSelector], function (convergentBillerAccountUsageDetails, convergentBillerSelectedServiceId) {
  return pathOr(null, [convergentBillerSelectedServiceId], convergentBillerAccountUsageDetails);
});
export var IsFetchingAccountUsageDetailsSelector = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.isFetchingAccountUsageDetails : false;
});
export var IsFetchingInvoicesSelector = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.isFetchingInvoices : false;
});
export var IsFetchingDepositsSelector = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.isFetchingDeposits : false;
});
export var IsFetchingSubscriberSummarySelector = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.isFetchingSubscriberSummary : false;
});
export var IsFetchingTreatmentDetailsSelector = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.isFetchingTreatmentDetails : false;
});
export var IsCreatingConvergentBillerAdjustmentSelector = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.isCreatingConvergentBillerAdjustment : false;
});
export var IsFetchingOrderDetailsSelector = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return !!(convergentBiller && convergentBiller.isFetchingOrderDetails);
});
export var ConvergentBillerOrderDetailsSelector = createSelector([CurrentConvergentBillerSelector, CurrentOrderIdSelector], function (convergentBiller, currentOrderId) {
  return pathOr(null, ['orderDetails', currentOrderId], convergentBiller);
});
export var CurrentOrderDetailsPaymentInstrumentSelector = createSelector([ConvergentBillerOrderDetailsSelector, CurrentOrderIdSelector], function (convergentBiller, currentOrderId) {
  var paymentInstruments = pathOr(null, ['PaymentInstruments'], convergentBiller);
  return paymentInstruments = (paymentInstruments || []).filter(function (paymentInstrument) {
    return paymentInstrument.PaymentStatus !== PAYMENT_STATUS.PENDING;
  });
});
export var ConvergentBillerOrderSubscribersSelector = createImmutableSelector([CurrentConvergentBillerSelector, CurrentOrderIdSelector], function (convergentBiller, currentOrderId) {
  return pathOr(null, ['orderSubscribers', currentOrderId], convergentBiller);
});
export var ConvergentBillerOrderTransferredSubscriberSelector = createImmutableSelector([ConvergentBillerOrderDetailsSelector, ConvergentBillerOrderSubscribersSelector, CurrentCustomerIdSelector], function (currentOrder, currentSubscribers, currentCustomerId) {
  if (currentOrder && currentOrder.TransferDetail && currentSubscribers && currentSubscribers.length) {
    var isTransferredFrom = currentOrder.TransferDetail.FromSubscriberId === convertStringToNumber(currentCustomerId);
    var trasferedSubscriberId = isTransferredFrom ? currentOrder.TransferDetail.ToSubscriberId : currentOrder.TransferDetail.FromSubscriberId;
    var transferedSubscriber = currentSubscribers.find(function (subscriber) {
      return subscriber.Id === trasferedSubscriberId;
    });
    return transferedSubscriber ? {
      isTransferredFrom: isTransferredFrom,
      id: transferedSubscriber.Id,
      displayName: getCustomerIdentifier(transferedSubscriber)
    } : null;
  }
  return null;
});
export var OrderStoresSelector = createImmutableSelector([ConvergentBillerOrderDetailsSelector, MetadataCodeTypeSelector(CODES.Stores)], function (orderDetails, stores) {
  if (orderDetails && orderDetails.Items.length) {
    var storeIds = [];
    orderDetails.Items.forEach(function (item) {
      if (pathOr(0, ['InventoryItems', 'length'], item)) {
        item.InventoryItems.forEach(function (inventoryItem) {
          if (inventoryItem.StoreId) {
            storeIds.push(inventoryItem.StoreId);
          }
        });
      }
    });
    if (storeIds.length) {
      return uniq(storeIds).map(function (storeId) {
        var stringStoreId = storeId.toString();
        var store = stores.find(function (store) {
          return store.Value === stringStoreId;
        });
        return store ? {
          storeId: storeId,
          storeName: store.Name
        } : undefined;
      }).filter(function (item) {
        return !!item;
      });
    } else {
      return EMPTY_ARRAY;
    }
  } else {
    return EMPTY_ARRAY;
  }
});
export var OrderDetailsPurchaseOrderNumberSelector = createSelector([ConvergentBillerOrderDetailsSelector], function (currentOrderDetails) {
  return pathOr(null, ['Items', '0', 'PurchaseOrderNumber'], currentOrderDetails);
});
export var HasOrderDetailTotalsSelector = createSelector([ConvergentBillerOrderDetailsSelector], function (orderDetails) {
  return !!(orderDetails && (orderDetails.Totals && (orderDetails.Totals.SubTotalAmount > 0 || orderDetails.Totals.DiscountAmount > 0 || orderDetails.Totals.LateFee > 0 || orderDetails.Totals.TerminationFee > 0 || orderDetails.Totals.TaxAmount > 0 || orderDetails.Totals.TotalAmount > 0 || orderDetails.Totals.ReturnAmount > 0) || orderDetails.ShippingMethod));
});
export var ConvergentBillerOrderProductIdsSelector = createSelector([ConvergentBillerOrderDetailsSelector], function (currentOrderDetails) {
  return isNil(currentOrderDetails) ? EMPTY_ARRAY : currentOrderDetails.Items.map(function (item) {
    return item.Product.Id;
  });
});
export var ConvergentBillerOrderPaymentInstruments = createSelector([ConvergentBillerOrderDetailsSelector], function (details) {
  return details && details.PaymentInstruments ? details.PaymentInstruments.map(function (_ref3) {
    var PaymentInstrument = _ref3.PaymentInstrument;
    return PaymentInstrument;
  }).asMutable({
    deep: true
  }) : EMPTY_ARRAY;
});
export var CurrentOrderItemTransactionSelector = createSelector([CurrentConvergentBillerSelector, CurrentOrderIdSelector], function (convergentBiller, currentOrderId) {
  return pathOr(null, ['orderTransactions', currentOrderId], convergentBiller);
});
var giftIsNotReedemed = function giftIsNotReedemed(_ref4) {
  var GiftRedemption = _ref4.GiftRedemption;
  return GiftRedemption && GiftRedemption.Status === GIFT_REDEMPTION_STATUS.AVAILABLE;
};
var orderCanBeCredited = function orderCanBeCredited(orderTransaction, paymentInstruments, userSecurityAttributes) {
  var totalAmount = pathOr(0, ['PurchaseOrder', 'Totals', 'TotalCreditableAmount'], orderTransaction);
  return totalAmount > 0 && paymentInstruments.length && getUpperLimitAccess(userSecurityAttributes, ISSUE_CREDIT_STANDARD_CURRENCY_LIMIT.id) > 0;
};
var orderCanBeCompleted = function orderCanBeCompleted(_ref5, userSecurityAttributes) {
  var OrderStatus = _ref5.OrderStatus;
  return hasAccess(userSecurityAttributes, ORDER_ACCESS) && OrderStatus === ORDER_STATUS.PENDING;
};
var canResendGiftNotification = function canResendGiftNotification(_ref6, userSecurityAttributes) {
  var Type = _ref6.Type,
    GiftRedemption = _ref6.GiftRedemption;
  return hasAccess(userSecurityAttributes, SEND_GIFT_ORDER_ACCESS) && Type === ORDER_TYPES.GIFT && GiftRedemption && !GiftRedemption.RedemptionOrderId && !GiftRedemption.Revoked;
};
var canResubmitOrder = function canResubmitOrder(_ref7, userSecurityAttributes) {
  var _ref7$Items = _ref7.Items,
    Items = _ref7$Items === void 0 ? [] : _ref7$Items,
    OrderStatus = _ref7.OrderStatus;
  var isBulkWithServices = any(function (item) {
    return item.IsBulkWithServices;
  }, Items);
  return hasAccess(userSecurityAttributes, RESUBMIT_ORDER_ACCESS) && !isBulkWithServices && OrderStatus === ORDER_STATUS.OPEN;
};
var canCancelOrder = function canCancelOrder(_ref8, userSecurityAttributes) {
  var CanBeCanceled = _ref8.CanBeCanceled;
  return hasAccess(userSecurityAttributes, CANCEL_ORDER_ACCESS) && CanBeCanceled;
};
export var CancelOrderErrorSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return pathOr(false, ['orderHistory', 'cancelOrderError'], selectedCustomer);
});
export var OrderDetailsMoreMenuItemsSelector = createSelector([ConvergentBillerOrderDetailsSelector, CurrentOrderItemTransactionSelector, ConvergentBillerOrderPaymentInstruments, IsDbss, UserSecurityAttributesSelector], function (orderDetails, orderTransaction, paymentInstruments, isDbss, userSecurityAttributes) {
  var items = [];
  if (orderDetails) {
    if (canCancelOrder(orderDetails, userSecurityAttributes)) {
      items.push({
        id: ORDER_DETAILS_MORE_MENU_CONSTANTS.CANCEL_ORDER,
        title: i18n.translate(CustomerCareLocaleKeys.CANCEL_ORDER)
      });
    }
    if (orderCanBeCompleted(orderDetails, userSecurityAttributes)) {
      items.push({
        id: ORDER_DETAILS_MORE_MENU_CONSTANTS.COMPLETE_ORDER,
        title: i18n.translate(CustomerCareLocaleKeys.ORDER_DETAILS.COMPLETE_ORDER)
      });
    }
    if (!isDbss && orderCanBeCredited(orderTransaction, paymentInstruments, userSecurityAttributes)) {
      items.push({
        id: ORDER_DETAILS_MORE_MENU_CONSTANTS.CREDIT_ORDER,
        title: i18n.translate(CustomerCareLocaleKeys.ORDER_DETAILS.CREDIT.APPLY)
      });
    }
    if (canResendGiftNotification(orderDetails, userSecurityAttributes)) {
      items.push({
        id: ORDER_DETAILS_MORE_MENU_CONSTANTS.RESEND_GIFT_NOTIFICATION,
        title: i18n.translate(CustomerCareLocaleKeys.ORDER_DETAILS.RESEND_NOTIFICATION)
      });
    }
    if (canResubmitOrder(orderDetails, userSecurityAttributes) && !orderDetails.FutureDatedOrder) {
      items.push({
        id: ORDER_DETAILS_MORE_MENU_CONSTANTS.RESUBMIT_ORDER,
        title: i18n.translate(CustomerCareLocaleKeys.ORDER_DETAILS.RESUBMIT_ORDER)
      });
    }
    if (giftIsNotReedemed(orderDetails)) {
      items.push({
        id: ORDER_DETAILS_MORE_MENU_CONSTANTS.REVOKE_GIFT,
        title: i18n.translate(CustomerCareLocaleKeys.ORDER_DETAILS.REVOKE_GIFT)
      });
    }
    if (orderDetails.IsOrderModifiable) {
      items.push({
        id: ORDER_DETAILS_MORE_MENU_CONSTANTS.EDIT_ORDER,
        title: i18n.translate(CustomerCareLocaleKeys.ORDER_DETAILS.EDIT_ORDER)
      });
    }
  }
  return items.length ? items : null;
});
export var OrderDetailsNotificationHistorySelector = createSelector([ConvergentBillerOrderDetailsSelector], function (orderDetails) {
  var history = pathOr([], ['GiftRedemption', 'Notifications'], orderDetails);
  var reversed = Immutable.asMutable(history).reverse();
  return Immutable(reversed);
});
var getMappedBRIs = function getMappedBRIs(bris, bulkDetails, periodTypes, bulkChargeTypes) {
  var activeBrisWithAmount = bris.filter(function (bri) {
    //The recurring charge are allowed to be 0, in that case, we need to display the priceData, hence checking for null priceData value
    return bri.Amount !== null && bri.DefaultActivationStatus !== BRI_ACTIVATION_STATUS.INACTIVE;
  });
  var pricingMap = groupBy(prop('BillerRuleConfigurationId'))(bulkDetails);
  return activeBrisWithAmount.map(function (briWithAmount) {
    var Name = briWithAmount.Name,
      BillerRuleConfigurationId = briWithAmount.BillerRuleConfigurationId,
      Amount = briWithAmount.Amount,
      CurrencyCode = briWithAmount.CurrencyCode,
      DiscountAmount = briWithAmount.DiscountAmount,
      Type = briWithAmount.Type,
      RecurringPeriodType = briWithAmount.RecurringPeriodType,
      BulkChargeTypeCode = briWithAmount.BulkChargeTypeCode,
      QuantityPricingTypeCode = briWithAmount.QuantityPricingTypeCode,
      StartQuantity = briWithAmount.StartQuantity,
      EndQuantity = briWithAmount.EndQuantity,
      FullUpfrontPayment = briWithAmount.FullUpfrontPayment;
    var schedule = pricingMap[BillerRuleConfigurationId] || [];
    var pricingSchedule = schedule.map(function (pricingEntry) {
      var isAfterStartDate = moment(pricingEntry.StartDate).isBefore(new Date()) || !pricingEntry.StartDate;
      var isBeforeEndDate = pricingEntry.EndDate && moment(pricingEntry.EndDate).isAfter(new Date());
      return pricingEntry.set('isActive', isAfterStartDate && (!pricingEntry.EndDate || isBeforeEndDate)).set('CurrencyCode', CurrencyCode);
    }).sort(function (a, b) {
      return moment(a.StartDate).isBefore(b.StartDate) ? -1 : 1; // Note: StartDates cannot be the same, so no need to have a 0 case
    });
    var recurringDescription = periodTypes.find(function (type) {
      return RecurringPeriodType === parseInt(type.Value, 10);
    });
    var bulkChargeType = bulkChargeTypes.find(function (chargeType) {
      return BulkChargeTypeCode === parseInt(chargeType.Value, 10);
    });
    if (recurringDescription) {
      recurringDescription = "".concat(i18n.translate(CustomerCareLocaleKeys.ORDER_DETAILS.RECURRING), " ").concat(recurringDescription.Name);
    } else if (FullUpfrontPayment) {
      recurringDescription = i18n.translate(CustomerCareLocaleKeys.ORDER_DETAILS.FULL_PRICE_PLUS_TAX);
    } else {
      recurringDescription = i18n.translate(CustomerCareLocaleKeys.ORDER_DETAILS.ONE_TIME);
    }
    var nameAddition = bulkChargeType ? " (".concat(bulkChargeType.Name, ")") : '';
    var name = "".concat(Name).concat(nameAddition);
    return {
      Amount: Amount,
      BillerRuleConfigurationId: BillerRuleConfigurationId,
      CurrencyCode: CurrencyCode,
      FullUpfrontPayment: FullUpfrontPayment,
      Type: Type,
      DiscountAmount: DiscountAmount,
      bulkChargeType: bulkChargeType,
      name: name,
      pricingSchedule: pricingSchedule,
      recurringDescription: recurringDescription,
      QuantityPricingTypeCode: QuantityPricingTypeCode,
      StartQuantity: StartQuantity,
      EndQuantity: EndQuantity
    };
  });
};
var getBriAmountTotal = function getBriAmountTotal(Amount, itemTotalQuantity, itemIncrementalQuantity, bulkDetails, isBulk, QuantityPricingTypeCode, StartQuantity, EndQuantity, BillerRuleConfigurationId, adHocDetails) {
  var isDiscount = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : false;
  if (isBulk && !isDiscount) {
    return pathOr(0, ['Amount'], find(propEq(BillerRuleConfigurationId, 'BillerRuleConfigurationId'), bulkDetails));
  } else if (QuantityPricingTypeCode === BILLER_RULE_QUANTITY_PRICE_TYPE.TIERED) {
    return itemIncrementalQuantity >= StartQuantity && itemIncrementalQuantity <= EndQuantity ? Amount : 0;
  } else if (QuantityPricingTypeCode === BILLER_RULE_QUANTITY_PRICE_TYPE.TAPERED) {
    return itemTotalQuantity >= StartQuantity && itemTotalQuantity <= EndQuantity ? Amount : 0;
  } else if (adHocDetails && adHocDetails.Amount && !isDiscount) {
    return adHocDetails.Amount;
  }
  return Amount || 0;
};
var getPaymentTypeMap = function getPaymentTypeMap(bris, defaultCurrencyCode, itemTotalQuantity, itemIncrementalQuantity, bulkDetails, adHocDetails) {
  var paymentTypeMap = groupBy(prop('recurringDescription'))(bris);
  Object.keys(paymentTypeMap).forEach(function (key) {
    paymentTypeMap[key] = paymentTypeMap[key].reduce(function (prev, _ref9) {
      var CurrencyCode = _ref9.CurrencyCode,
        DiscountAmount = _ref9.DiscountAmount,
        Amount = _ref9.Amount,
        bulkChargeType = _ref9.bulkChargeType,
        QuantityPricingTypeCode = _ref9.QuantityPricingTypeCode,
        StartQuantity = _ref9.StartQuantity,
        EndQuantity = _ref9.EndQuantity,
        BillerRuleConfigurationId = _ref9.BillerRuleConfigurationId;
      var amount = getBriAmountTotal(Amount, itemTotalQuantity, itemIncrementalQuantity, bulkDetails, !!bulkChargeType, QuantityPricingTypeCode, StartQuantity, EndQuantity, BillerRuleConfigurationId, adHocDetails);
      var discountAmount = getBriAmountTotal(DiscountAmount, itemTotalQuantity, itemIncrementalQuantity, bulkDetails, !!bulkChargeType, QuantityPricingTypeCode, StartQuantity, EndQuantity, BillerRuleConfigurationId, adHocDetails, true);
      return Object.assign(prev, {
        CurrencyCode: CurrencyCode || defaultCurrencyCode,
        sum: prev.sum + amount,
        discount: prev.discount + discountAmount,
        bulkChargeType: prev.bulkChargeType || bulkChargeType
      });
    }, {
      sum: 0,
      discount: 0,
      CurrencyCode: defaultCurrencyCode,
      bulkChargeType: null
    });
  });
  return paymentTypeMap;
};
var getDepositInformation = function getDepositInformation(deposits, defaultCurrencyCode) {
  return deposits.reduce(function (prev, _ref10) {
    var TotalAmount = _ref10.TotalAmount;
    return Object.assign(prev, {
      sum: prev.sum + TotalAmount
    });
  }, {
    sum: 0,
    CurrencyCode: defaultCurrencyCode
  });
};
var getPricingSchedules = function getPricingSchedules(bris) {
  return bris.reduce(function (previous, _ref11) {
    var name = _ref11.name,
      pricingSchedule = _ref11.pricingSchedule;
    return Object.assign(previous, _defineProperty({}, name, pricingSchedule));
  }, {});
};
var hasPricingSchedule = function hasPricingSchedule(bulkDetails) {
  return bulkDetails.some(function (details) {
    return details.StartDate || details.EndDate;
  });
};
var getOrderItemDisplayItems = function getOrderItemDisplayItems(orderId, _ref12, periodTypes, bulkChargeTypes, instancePropertiesLabels, orderServiceDetails, orderItemChangeType) {
  var Items = _ref12.Items;
  var dbssOfferItems = Items.filter(function (_ref13) {
    var _ref13$PricingPlan$Bi = _ref13.PricingPlan.BillerRuleInstanceThumbnails,
      BillerRuleInstanceThumbnails = _ref13$PricingPlan$Bi === void 0 ? [] : _ref13$PricingPlan$Bi,
      Product = _ref13.Product;
    return BillerRuleInstanceThumbnails.length && Product.ProductClassification !== PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE;
  });
  var dbssServiceFeatures = Items.filter(function (_ref14) {
    var _ref14$PricingPlan$Bi = _ref14.PricingPlan.BillerRuleInstanceThumbnails,
      BillerRuleInstanceThumbnails = _ref14$PricingPlan$Bi === void 0 ? [] : _ref14$PricingPlan$Bi,
      Product = _ref14.Product;
    return BillerRuleInstanceThumbnails.length && Product.ProductClassification === PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE;
  });
  var ott = Items.filter(function (_ref15) {
    var _ref15$PricingPlan$Bi = _ref15.PricingPlan.BillerRuleInstanceThumbnails,
      BillerRuleInstanceThumbnails = _ref15$PricingPlan$Bi === void 0 ? [] : _ref15$PricingPlan$Bi;
    return !BillerRuleInstanceThumbnails.length;
  });
  var getActionItems = memoize(function (item) {
    var _item$AppointmentRese;
    var actionsItems = [];
    if ((_item$AppointmentRese = item.AppointmentReservations) !== null && _item$AppointmentRese !== void 0 && _item$AppointmentRese.length) {
      actionsItems.push({
        id: ACTIONS_ITEMS.VIEW_APPOINTMENT_DETAILS,
        title: i18n.translate(CustomerCareLocaleKeys.ORDER_HISTORY.ACTION_ITEMS.VIEW_APPOINTMENT_DETAILS)
      });
    }
    if (item.IsBulkWithServices) {
      actionsItems.push({
        id: ACTIONS_ITEMS.VIEW_SERVICES_ID,
        title: i18n.translate(CustomerCareLocaleKeys.ORDER_HISTORY.ACTION_ITEMS.VIEW_SERVICES)
      });
    }
    if (item.hasAttributes && !item.IsBulkWithServices) {
      actionsItems.push({
        id: ACTIONS_ITEMS.VIEW_SERVICES_ATTRIBUTES_ID,
        title: i18n.translate(CustomerCareLocaleKeys.ORDER_DETAILS.VIEW_SERVICE_ATTRIBUTES)
      });
    }
    if (item.IsBulkWithServices) {
      actionsItems.push({
        id: ACTIONS_ITEMS.IMPORT_SERVICE_ATTRIBUTES_ID,
        title: i18n.translate(CustomerCareLocaleKeys.ORDER_HISTORY.ACTION_ITEMS.IMPORT_SERVICE_ATTRIBUTES)
      }, {
        id: ACTIONS_ITEMS.EXPORT_SERVICES_TEMPLATE_ID,
        title: i18n.translate(CustomerCareLocaleKeys.ORDER_HISTORY.ACTION_ITEMS.EXPORT_SERVICES_TEMPLATE)
      });
    }
    if (item.hasPricingSchedule) {
      actionsItems.push({
        id: ACTIONS_ITEMS.VIEW_PRICING_SCHEDULE_ID,
        title: i18n.translate(CustomerCareLocaleKeys.ORDER_HISTORY.ACTION_ITEMS.VIEW_PRICING_SCHEDULE)
      });
    }
    return actionsItems;
  });
  var getServiceDetails = function getServiceDetails(itemId) {
    return find(propEq(itemId, 'OrderItemId'))(orderServiceDetails[orderId]) || null;
  };
  var mappedOTT = ott.map(function (_ref16) {
    var BulkExtractItemDetail = _ref16.BulkExtractItemDetail,
      Id = _ref16.Id,
      IsBulkWithServices = _ref16.IsBulkWithServices,
      OfferingName = _ref16.OfferingName,
      OrderedOfferingId = _ref16.OrderedOfferingId,
      OfferingInstanceId = _ref16.OfferingInstanceId,
      OfferingId = _ref16.OfferingId,
      Product = _ref16.Product,
      PricingPlan = _ref16.PricingPlan,
      GrossAmount = _ref16.GrossAmount,
      Amount = _ref16.Amount,
      ReturnAmount = _ref16.ReturnAmount,
      ServiceAttributeValues = _ref16.ServiceAttributeValues,
      WorkflowInstance = _ref16.WorkflowInstance,
      WorkflowInstanceId = _ref16.WorkflowInstanceId,
      InstanceProperties = _ref16.InstanceProperties,
      OrderItemChangeType = _ref16.OrderItemChangeType;
    var instanceProperties = {};
    forEachObjIndexed(function (value, key) {
      if (!isNil(instancePropertiesLabels) && !isNil(instancePropertiesLabels[key])) {
        instanceProperties[instancePropertiesLabels[key]] = value;
      } else {
        instanceProperties[key] = value;
      }
    }, InstanceProperties || {});
    var details = getServiceDetails(Id);
    var numAttributes = 0;
    if (details) {
      numAttributes = details.AvailableServiceAttributes && details.AvailableServiceAttributes.length + details.ServiceAttributeValues.length;
    }
    var mappedItem = {
      Amount: Amount,
      BulkExtractItemDetail: BulkExtractItemDetail,
      orderItemChangeTypeValue: orderItemChangeType === null || orderItemChangeType === void 0 ? void 0 : orderItemChangeType.find(function (type) {
        return +type.Value === +OrderItemChangeType;
      }),
      CurrencyCode: PricingPlan.Currency,
      displayName: "".concat(Product.Name, ": ").concat(PricingPlan.Name),
      GrossAmount: GrossAmount,
      hasAttributes: !!numAttributes,
      Id: Id,
      instanceProperties: InstanceProperties ? instanceProperties : undefined,
      IsBulkWithServices: IsBulkWithServices,
      isOTT: true,
      OfferingId: OfferingId,
      OfferingInstanceId: OfferingInstanceId,
      OfferingName: OfferingName,
      OrderedOfferingId: OrderedOfferingId,
      pricingPlanId: PricingPlan.Id,
      pricingPlanName: PricingPlan.Name,
      productId: Product.Id,
      productName: Product.Name,
      quantity: 1,
      ReturnAmount: ReturnAmount,
      ServiceAttributeValues: ServiceAttributeValues,
      WorkflowInstance: WorkflowInstance,
      WorkflowInstanceId: WorkflowInstanceId
    };
    return Object.assign({}, mappedItem, {
      actionItems: getActionItems(mappedItem)
    });
  });
  var getOfferingOptionTotalQuantity = function getOfferingOptionTotalQuantity(OfferingOptionPriceId) {
    var items = filter(propEq(OfferingOptionPriceId, 'OfferingOptionPriceId'))(dbssOfferItems);
    return items.length;
  };
  var getOfferingOptionIncrementalQuantity = function getOfferingOptionIncrementalQuantity(OfferingOptionPriceId, Id) {
    return findIndex(propEq(Id, 'Id'), filter(propEq(OfferingOptionPriceId, 'OfferingOptionPriceId'))(dbssOfferItems)) + 1;
  };
  var getMappedDBSS = function getMappedDBSS(dbssItem) {
    var AdHocOverrideDetails = dbssItem.AdHocOverrideDetails,
      AppointmentReservations = dbssItem.AppointmentReservations,
      BulkExtractItemDetail = dbssItem.BulkExtractItemDetail,
      Discounts = dbssItem.Discounts,
      Id = dbssItem.Id,
      IsBulkWithServices = dbssItem.IsBulkWithServices,
      _dbssItem$Deposits = dbssItem.Deposits,
      Deposits = _dbssItem$Deposits === void 0 ? [] : _dbssItem$Deposits,
      OfferingName = dbssItem.OfferingName,
      OrderedOfferingId = dbssItem.OrderedOfferingId,
      OfferingId = dbssItem.OfferingId,
      OfferingInstanceId = dbssItem.OfferingInstanceId,
      Product = dbssItem.Product,
      PricingPlan = dbssItem.PricingPlan,
      ServiceAttributeValues = dbssItem.ServiceAttributeValues,
      _dbssItem$OrderItemBi = dbssItem.OrderItemBillerRuleDetails,
      OrderItemBillerRuleDetails = _dbssItem$OrderItemBi === void 0 ? [] : _dbssItem$OrderItemBi,
      WorkflowInstance = dbssItem.WorkflowInstance,
      WorkflowInstanceId = dbssItem.WorkflowInstanceId,
      OfferingOptionPriceId = dbssItem.OfferingOptionPriceId,
      ServiceFeatureProductAssociation = dbssItem.ServiceFeatureProductAssociation,
      Status = dbssItem.Status,
      OrderItemChangeType = dbssItem.OrderItemChangeType;
    var details = getServiceDetails(Id);
    var numAttributes = 0;
    if (details) {
      numAttributes = details.AvailableServiceAttributes && details.AvailableServiceAttributes.length + details.ServiceAttributeValues.length;
    }
    var dbssBRIs = PricingPlan && PricingPlan.PricingPlanBillerRuleInstances ? [].concat(_toConsumableArray(PricingPlan.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances), _toConsumableArray(PricingPlan.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances)) : [];
    var mergedDBSSbris = PricingPlan.BillerRuleInstanceThumbnails.map(function (bri) {
      var foundBRI = dbssBRIs.find(function (dbssBRI) {
        return dbssBRI.Id === bri.Id;
      }) || EMPTY_OBJECT;
      return _objectSpread(_objectSpread({}, foundBRI), bri);
    });
    var bris = getMappedBRIs(mergedDBSSbris, OrderItemBillerRuleDetails, periodTypes, bulkChargeTypes);
    var itemTotalQuantity = getOfferingOptionTotalQuantity(OfferingOptionPriceId);
    var itemIncrementalQuantity = getOfferingOptionIncrementalQuantity(OfferingOptionPriceId, Id);
    var mappedItem = {
      AppointmentReservations: AppointmentReservations,
      BulkExtractItemDetail: BulkExtractItemDetail,
      depositInformation: getDepositInformation(Deposits, PricingPlan.Currency),
      orderItemChangeTypeValue: orderItemChangeType === null || orderItemChangeType === void 0 ? void 0 : orderItemChangeType.find(function (type) {
        return +type.Value === +OrderItemChangeType;
      }),
      Discounts: Discounts,
      displayName: "".concat(Product.Name, ": ").concat(PricingPlan.Name),
      hasAttributes: !!numAttributes,
      hasPricingSchedule: hasPricingSchedule(OrderItemBillerRuleDetails),
      Id: Id,
      LifeCycleId: dbssItem.LifeCycleId || '',
      IsBulkWithServices: IsBulkWithServices,
      OfferingId: OfferingId,
      OfferingInstanceId: OfferingInstanceId,
      OfferingName: OfferingName,
      OrderedOfferingId: OrderedOfferingId,
      paymentTypeMap: getPaymentTypeMap(bris, PricingPlan.Currency, itemTotalQuantity, itemIncrementalQuantity, OrderItemBillerRuleDetails, AdHocOverrideDetails),
      pricingPlanId: PricingPlan.Id,
      pricingPlanName: pathOr(PricingPlan.Name, ['InvoiceText'], AdHocOverrideDetails),
      pricingSchedules: getPricingSchedules(bris),
      productId: Product.Id,
      productName: Product.Name,
      quantity: OrderItemBillerRuleDetails.length ? OrderItemBillerRuleDetails[0].Quantity : 1,
      ServiceAttributeValues: ServiceAttributeValues,
      ServiceFeatureProductAssociation: ServiceFeatureProductAssociation,
      Status: Status,
      WorkflowInstance: WorkflowInstance,
      WorkflowInstanceId: WorkflowInstanceId
    };
    return Object.assign({}, mappedItem, {
      actionItems: getActionItems(mappedItem)
    });
  };
  var mappedDBSSOfferItems = dbssOfferItems.map(getMappedDBSS);
  var mappedDBSSServiceFeatures = dbssServiceFeatures.length ? groupBy(function (serviceFeature) {
    return serviceFeature.ServiceFeatureProductAssociation.ServiceIdentifierValue;
  })(dbssServiceFeatures.map(getMappedDBSS)) : null;
  var groupedMappedItems = mappedOTT.length || mappedDBSSOfferItems.length ? groupBy(function (item) {
    return item.OfferingInstanceId || item.OrderedOfferingId;
  }, [].concat(_toConsumableArray(mappedOTT), _toConsumableArray(mappedDBSSOfferItems))) : null;
  return {
    Items: groupedMappedItems,
    ServiceFeatures: mappedDBSSServiceFeatures
  };
};
export var CurrentOrderItemDisplayItemsSelector = createSelector([ConvergentBillerOrderDetailsSelector, MetadataCodeLoadedSelector(CODES.PeriodType), MetadataCodeTypeSelector(CODES.PeriodType), MetadataCodeLoadedSelector(CODES.BulkChargeType), MetadataCodeTypeSelector(CODES.BulkChargeType), AvailableProductsInstancePropertiesLabelSelector, ConvergentBillerOrderServiceDetailsSelector, MetadataCodeTypeSelector(CODES.OrderItemChangeType)], function (currentOrder, arePeriodTypesLoaded, periodTypes, areBulkTypesLoaded, bulkTypes, instancePropertiesLabels, orderServiceDetails, orderItemChangeType) {
  return currentOrder && arePeriodTypesLoaded && areBulkTypesLoaded && orderServiceDetails ? clone(getOrderItemDisplayItems(currentOrder.Id, currentOrder, periodTypes, bulkTypes, instancePropertiesLabels, orderServiceDetails, orderItemChangeType)) : {};
});
export var CurrentOrderItemsBulkStatusViewModelSelector = createSelector([CurrentOrderItemDisplayItemsSelector], function (currentOrderItemDisplayItems) {
  var orderItemsBulkStatuses = {
    statuses: [],
    summary: {}
  };
  var mapBulkServices = function mapBulkServices(currentOrderOffers) {
    currentOrderOffers.forEach(function (offerItems) {
      offerItems.forEach(function (item) {
        if (item.IsBulkWithServices && item.BulkExtractItemDetail && IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_STATUSES.NOT_STARTED !== item.BulkExtractItemDetail.BulkExportStatus) {
          orderItemsBulkStatuses.statuses.push({
            glyph: 'file-text',
            path: item.BulkExtractItemDetail.FileLocation ? parseFilenameFromPath(item.BulkExtractItemDetail.FileLocation) : '',
            pricingPlanId: item.pricingPlanId,
            pricingPlanName: item.displayName,
            statusId: item.BulkExtractItemDetail.BulkExportStatus,
            title: item.displayName
          });
        }
      });
    });
  };
  if (currentOrderItemDisplayItems.Items) {
    mapBulkServices(values(currentOrderItemDisplayItems.Items));
  }
  if (currentOrderItemDisplayItems.ServiceFeatures) {
    mapBulkServices(values(currentOrderItemDisplayItems.ServiceFeatures));
  }
  orderItemsBulkStatuses.summary = groupBy(function (itemStatus) {
    return itemStatus.statusId;
  }, orderItemsBulkStatuses.statuses);
  return orderItemsBulkStatuses;
});
var OrderItemSelectedToDisplayServiceAttributesFor = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller.orderItemToDisplayServiceAttributesFor;
});
var getKeyValueObjectForServiceAttributes = function getKeyValueObjectForServiceAttributes(orderItems, orderItemId) {
  var response = {};
  var order = orderItems.find(function (item) {
    return item.Id === orderItemId;
  }) || {};
  (order.ServiceAttributeValues || []).forEach(function (_ref17) {
    var ServiceAttributeName = _ref17.ServiceAttributeName,
      Value = _ref17.Value;
    response[ServiceAttributeName] = Value;
  });
  return response;
};
export var OrderItemToDisplayServiceAttributesFor = createSelector([OrderItemSelectedToDisplayServiceAttributesFor, ConvergentBillerOrderDetailsSelector], function (orderItemId, currentOrderDetails) {
  return orderItemId && currentOrderDetails ? getKeyValueObjectForServiceAttributes(currentOrderDetails.Items, orderItemId) : null;
});
var getKeyValueObjectForAdditionalProperties = function getKeyValueObjectForAdditionalProperties(properties) {
  var response = {};
  properties.forEach(function (property) {
    response[property.Name] = property.Values.join('; ');
  });
  return response;
};
export var AdditionalAttributesForOrder = createSelector([ConvergentBillerOrderDetailsSelector], function (currentOrderDetails) {
  return currentOrderDetails && currentOrderDetails.AdditionalProperties ? getKeyValueObjectForAdditionalProperties(currentOrderDetails.AdditionalProperties) : null;
});
export var OrderWorkflowSummarySelector = createSelector([ConvergentBillerOrderDetailsSelector], function (currentOrderDetails) {
  return currentOrderDetails && currentOrderDetails.Workflows ? currentOrderDetails.Workflows.map(function (item) {
    return item.set('DeliveryCapabilityName', item.DeliveryCapabilityName || i18n.translate(CustomerCareLocaleKeys.ORDER_DETAILS.DEFAULT_DELIVERY_CAPABILITY_NAME)).set('workflowState', WorkflowStateEnum[item.CurrentStateCode]);
  }).asMutable({
    deep: true
  }) : EMPTY_ARRAY;
});
export var IsApplyingCreditSelector = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.isApplyingCredit : false;
});
export var ApplyCreditErrorSelector = createSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller ? convergentBiller.applyCreditError : null;
});
export var CurrentOrderServiceIdentifiersSelector = createSelector([ConvergentBillerOrderServiceDetailsSelector, CurrentOrderIdSelector], function (convergentBillerOrderServiceDetails, currentOrderId) {
  var serviceAttributeValues = [];
  var orderItems = pathOr(null, [currentOrderId], convergentBillerOrderServiceDetails);
  if (orderItems) {
    serviceAttributeValues = flatten(pluck('ServiceAttributeValues')(orderItems));
  }
  return serviceAttributeValues.filter(function (serviceAttributeValue) {
    return serviceAttributeValue && serviceAttributeValue.IsServiceIdentifier;
  });
});
export var OrderContractDetailsSelector = createSelector([ConvergentBillerOrderDetailsSelector], function (currentOrderDetails) {
  return (currentOrderDetails && currentOrderDetails.Items || EMPTY_ARRAY).reduce(function (orderContractDetails, item) {
    return item.OrderContractInstance ? item.OrderContractInstance : orderContractDetails;
  }, null);
});
export var OrderContractExternalContractIdSelector = createSelector([OrderContractDetailsSelector], function (orderContractDetails) {
  return pathOr(i18n.translate(CustomerCareLocaleKeys.EMPTY_VALUE_NA), ['ExternalContractId'], orderContractDetails);
});
export var ServiceFeatureHasBreachedUsageCapsWithRestrictUsageSelector = createSelector([ConvergentBillerSubscriberSummarySelector], function (subscriberSummary) {
  var _subscriberSummary$Ac;
  return ((subscriberSummary === null || subscriberSummary === void 0 ? void 0 : (_subscriberSummary$Ac = subscriberSummary.AccountSummaries[0]) === null || _subscriberSummary$Ac === void 0 ? void 0 : _subscriberSummary$Ac.Services) || []).reduce(function (acc, item) {
    var _item$ServiceIdentifi;
    if (item !== null && item !== void 0 && (_item$ServiceIdentifi = item.ServiceIdentifier) !== null && _item$ServiceIdentifi !== void 0 && _item$ServiceIdentifi.Value) {
      acc[item.ServiceIdentifier.Value] = !!((item === null || item === void 0 ? void 0 : item.UsageCaps) || []).find(function (cap) {
        return cap.Breached && (cap === null || cap === void 0 ? void 0 : cap.UsageCapBehavior) === USAGE_CAP_BEHAVIOR_TYPES.RestrictUsage;
      });
    }
    return acc;
  }, {});
});
export var CurrentCappedServicesSelector = createSelector([ConvergentBillerSubscriberSummarySelector, ServiceFeatureHasBreachedUsageCapsWithRestrictUsageSelector], function (subscriberSummary, restrictedUsageCaps) {
  var _subscriberSummary$Ca, _subscriberSummary$Ca2;
  var breachedServices = ((subscriberSummary === null || subscriberSummary === void 0 ? void 0 : (_subscriberSummary$Ca = subscriberSummary.CappedServices) === null || _subscriberSummary$Ca === void 0 ? void 0 : _subscriberSummary$Ca.ServiceIdentifiers) || []).filter(function (serviceIdentifier) {
    return serviceIdentifier.Value && (restrictedUsageCaps === null || restrictedUsageCaps === void 0 ? void 0 : restrictedUsageCaps[serviceIdentifier.Value]);
  });
  return subscriberSummary !== null && subscriberSummary !== void 0 && subscriberSummary.CappedServices ? {
    CapResetDate: subscriberSummary === null || subscriberSummary === void 0 ? void 0 : (_subscriberSummary$Ca2 = subscriberSummary.CappedServices) === null || _subscriberSummary$Ca2 === void 0 ? void 0 : _subscriberSummary$Ca2.CapResetDate,
    ServiceIdentifiers: breachedServices.length ? breachedServices : null
  } : EMPTY_OBJECT;
});
export var CurrentCappedAccountSelector = createSelector(ConvergentBillerSubscriberSummarySelector, function (subscriberSummary) {
  if (!subscriberSummary || !subscriberSummary.AccountSummaries) {
    return EMPTY_ARRAY;
  }
  var caps = pluck('UsageCaps')(subscriberSummary.AccountSummaries.asMutable({
    deep: true
  }));
  return caps && caps[0] ? caps[0].filter(function (cap) {
    return cap && cap.Breached;
  }) : null;
});
export var SelectedOfferAccountDetailsSelector = createSelector([CurrentConvergentBillerSelector, RouteParams], function (convergentBiller, routeParams) {
  var offerings = pathOr([], ['accountDetails', 'offerings'], convergentBiller);
  return offerings.find(function (offering) {
    return offering.OfferingId === routeParams.offeringId;
  });
});
export var PeriodTypeOptionsSelector = createImmutableSelector([MetadataOptionsForCodeValuesSelector(CODES.PeriodType)], function (codeTableValues) {
  return codeTableValues.filter(function (pt) {
    return pt.value !== PERIOD_TYPES.HOURLY && pt.value !== PERIOD_TYPES.YEARLY;
  });
});
export var SelectedOfferType = createSelector([SelectedOfferAccountDetailsSelector], function (selectedOfferAccountDetailsSelector) {
  return selectedOfferAccountDetailsSelector ? selectedOfferAccountDetailsSelector.OfferType : null;
});
export var CreditLimitSummarySelector = createImmutableSelector([ConvergentBillerSubscriberSummarySelector], function (convergentBillerSubscriberSummary) {
  return convergentBillerSubscriberSummary ? convergentBillerSubscriberSummary.CreditLimitSummary : EMPTY_OBJECT;
});
export var CreditLimitBreachedSelector = createImmutableSelector([CreditLimitSummarySelector], function (creditLimitSummary) {
  return creditLimitSummary ? creditLimitSummary.CreditLimitBreached : false;
});
export var IsUpdatingDashboardEntitlementStatusSelector = createImmutableSelector([ConvergentBillerSelector], function (convergentBiller) {
  return convergentBiller.isUpdatingEntitlementStatus;
});
export var SelectedOfferingAssignedPaymentInstrumentSelector = createImmutableSelector([ConvergentBillerSubscriberOfferingSummariesSelector, RouteParams], function (offeringSummaries, routeParams) {
  if (routeParams.offeringInstanceId) {
    var offering = (offeringSummaries || []).find(function (offeringSummary) {
      return offeringSummary.OfferingInstanceId === routeParams.offeringInstanceId;
    });
    return pathOr(false['PaymentInstrument', 'Id'], offering) ? offering.PaymentInstrument : null;
  }
  return null;
});
export var OrderContractMapSelector = createSelector([ConvergentBillerOrderDetailsSelector], function (currentOrderDetails) {
  // same contract is populated for each offering instance item. as of now only one contract per offeringInstance is supported
  var contracts = {};
  (currentOrderDetails && currentOrderDetails.Items || EMPTY_ARRAY).forEach(function (_ref18) {
    var OfferingInstanceId = _ref18.OfferingInstanceId,
      OrderContractInstance = _ref18.OrderContractInstance;
    if (OfferingInstanceId && OrderContractInstance) {
      contracts[OfferingInstanceId] = OrderContractInstance;
    }
  });
  return contracts;
});
export var AllOrderContractsSelector = createSelector([OrderContractMapSelector], function (orderContractMap) {
  return Object.values(orderContractMap || {});
});